import React, { useEffect, useState } from "react";
import { Badge, Pane, IconButton, TextInput, Spinner } from "evergreen-ui";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { CheckCircle } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

const ReconciliationDateInput = ({
  bank,
  reconciliationDateHandler,
  isLoading,
}) => {
  const [reconciliationDate, setReconciliationDate] = useState("");

  const showButtonHandler = () => {
    // Add check to ensure bank exists before accessing its properties
    if (!bank) return false;
    if (!reconciliationDate && !bank.reconciliationDate) return false;

    return (
      reconciliationDate !==
      new Date(bank.reconciliationDate).toISOString().slice(0, 10)
    );
  };

  useEffect(() => {
    if (!bank) return;
    console.log(new Date(bank.reconciliationDate).toISOString().slice(0, 10));
    console.log("reconciliationDate", reconciliationDate);

    setReconciliationDate(
      bank.reconciliationDate
        ? new Date(bank.reconciliationDate).toISOString().slice(0, 10)
        : ""
    );
  }, [bank]);

  return (
    <Pane
      display="flex"
      alignItems="center"
      justifyItems="center"
      flexDirection="column"
      gap={5}
      flex={1}
    >
      <Badge color="#F5F5F5" width="fit-content">
        Conciliado até:
      </Badge>
      <div className="flex gap-2">
        <TextInput
          id="reconciliationDate"
          name="reconciliationDate"
          type="date"
          width="120px"
          value={reconciliationDate || ""}
          onChange={(e) => setReconciliationDate(e.target.value)}
          disabled={isLoading}
        />
        {showButtonHandler() && (
          <Tooltip title="Confirmar" arrow placement="bottom">
            {isLoading ? (
              <div className="flex items-center justify-center w-[32px]">
                <Spinner size={16} />
              </div>
            ) : (
              <IconButton
                icon={<CheckCircle sx={{ color: "#52BD95" }} />}
                onClick={() =>
                  reconciliationDateHandler(bank, reconciliationDate)
                }
              />
            )}
          </Tooltip>
        )}
      </div>
    </Pane>
  );
};

export default ReconciliationDateInput;
